import Candidato from "./candidato";
import Documento from "./documento";
import Analise from "./analise";
import Status from "./status";
import StatusRegistroMatricula from "./statusregistromatricula";
import Historico from "./historico";

export default class PreMatricula {
  constructor(id='', candidato = new Candidato(), docs=[], analises=[], status= new Status(), historico = [], pendenciasInscricao = [], statusRegistroMatricula = new StatusRegistroMatricula(), valorRefSalario, chamadaUtilizaCadunico) {
    this.id = id;
    this.candidato = new Candidato(candidato.modalidade, candidato.classificacao, candidato.endereco, candidato.contato, candidato.dadosPessoais);
    this.documentos = docs.map(d => new Documento(d.id, d.descricao, d.instrucao, d.modelo, d.arquivos, d.obrigatorio));
    this.analises = analises.map(d => new Analise(d.id, d.descricao, d.status, d.parecer, d.recurso, d.parecerDoRecurso, d.permiteParecer, d.permiteParecerDoRecurso));
    this.status = status;
    this.historico = historico.map (d => new Historico(d.id, d.descricao, d.instante, d.usuario));
    this.pendenciasInscricao = pendenciasInscricao;
    this.statusRegistroMatricula = statusRegistroMatricula;
    this.valorRefSalario = valorRefSalario;
    this.chamadaUtilizaCadunico = chamadaUtilizaCadunico;
  }
}